#import "./CanvasBlockFields.graphql"
#import "./CanvasEntityFields.graphql"

fragment CanvasFields on Canvas {
  id
  title
  architecture
  agentRuntimeChat
  sourceCode
  createdAt
  updatedAt
  organization {
    name
    logoUrl
    brandProfile {
      primaryColor
      secondaryColor
      accentColor
      fontStyle
      cornerStyle
    }
    complianceProfile {
      disclosure
      dealerName
      dealerEnabled
      dealerLogoUrl
      companyName
      companyLogoUrl
    }
  }
  advisor {
    name
    email
    profileImageUrl
  }
  blocks {
    id
    ...CanvasBlockFields
  }
  entities {
    id
    ...CanvasEntityFields
  }
}
